import React, { useState } from "react";

import { useAppSelector, useAppDispatch } from "../../app/hooks";
import {} from "./filterSlice";

export function Filter() {
    const dispatch = useAppDispatch();
    const [incrementAmount, setIncrementAmount] = useState("4");

    const incrementValue = Number(incrementAmount) || 0;

    return (
        <>
            - priv all
            <br />
            - priv
            <br />
            - fin
            <br />
            - fdoe
            <br />
            - protos
            <br />
        </>
    );
}
